import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EntCarrerasView from './EntCarrerasView';
import * as ROUTES from '../../../router/Routes';

const EntCarrerasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.entCarreras}
      routes={[ROUTES.controlEstudios]}
    >
      <EntCarrerasView />
    </ContainerTemplate>
  );
};

export default EntCarrerasModule;
